
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getJobstatus} from 'sr/utils/api/masterData/jobstatus/getJobstatus'
export const fetchjobstatus = createAsyncThunk(
  'getJobstatus',
  async () => {
    const response = await getJobstatus()
    return response?.data
  }
)


